<template>
    <button id="ContactButton" @click="openContact" aria-label="back" class="btnfx btnfx__clickflash">
      
      <IconLetter></IconLetter>
        <span>Contact</span>
    </button>
</template>
<script>
export default {
    methods: {
        openContact() {
            app.api.PageManager.openContentComponentFromID(2373);
        }
    },
    computed: {
        onHomePage() {
            this.$route;
            return app.api.PageManager.onHomePage()
        }
    }
}
</script>
<style lang="scss" scoped>
#ContactButton {
    right: 155px;
    top: 80px;
    display: flex;

    img {
        width: 24px;
    }

   
}
</style>